import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './ServiceSection.module.css';

import useEmblaCarousel from 'embla-carousel-react';
import Fade from 'embla-carousel-fade';

function ServiceSection({ serviceSection }) {

    const [sectionImage, setSectionImage] = useState(serviceSection ? serviceSection.fallbackImagePath : "");
    const serviceCapsuleItems = serviceSection.serviceItems;
    const [activeServiceItem, setActiveServiceItem] = useState({});

    const [activeImagePaths, setActiveImagePaths] = useState(serviceSection.serviceImagePaths);

    const [activeImageId, setActiveImageId] = useState(0); // id for the active image 

    const emblaApiOptions = {
        loop: true,
    };
    const emblaApiPlugins = [Fade()];
    const [emblaRef, emblaApi] = useEmblaCarousel(emblaApiOptions, emblaApiPlugins);

    const scrollPrevious = () => emblaApi?.scrollPrev();
    const scrollNext = () => emblaApi?.scrollNext();


    const onSelect = useCallback(() => {
        if (!emblaApi) return;
        setActiveImageId(emblaApi.selectedScrollSnap());    //set the active image id to match embla's selected slide
    }, [emblaApi, setActiveImageId])    // if embla/setActiveImageId haven't changed between renders, don't run

    useEffect(() => {
        if (!emblaApi) return;
        onSelect();
        emblaApi.on("select", onSelect); // when embla's selected slide changes, run onSelect (which matches the active image id to embla's selected slide)
    }, [emblaApi, onSelect])        // if embla / onSelect haven't changed/run between renders, don't run

    useEffect(() => {
        if (emblaApi) {
            emblaApi.reInit(emblaApiOptions, emblaApiPlugins);
            emblaApi.scrollTo(0);

            onSelect();
            // when the data changes; which doesn't happen here atp,  but it's here if needed later. things like fading the tiles away etc
        }
    }, [emblaApi, onSelect, activeImagePaths]); // don't run if the paths etc haven't changed

    useEffect(() => {
        if (emblaApi) {
            emblaApi.scrollTo(activeImageId);  // scroll embla to the slide matching the active image id when it changes
        }
    }, [emblaApi, activeImageId]);  // don't run if the active image id hasn't changed, or embla etc








    /* could probably delete */
    function changeServiceItem(selectedItem) {
        if (activeServiceItem.id == selectedItem.id) {
            setActiveServiceItem({});
            setActiveImagePaths(serviceSection.serviceImagePaths);

        } else {
            setActiveServiceItem(selectedItem);
            if (selectedItem.serviceItemImagePaths) {
                setActiveImagePaths(selectedItem.serviceItemImagePaths);
            } else { setActiveImagePaths(serviceSection.serviceImagePaths); }
        }
    }



    return (

        <div id={serviceSection.id} className={styles.serviceSection}>
            <div className={styles.embla} onClick={() => scrollNext()}>
                <div className={styles.embla__viewport} ref={emblaRef}>
                    <div className={styles.embla__container}>

                        {activeImagePaths ?
                            activeImagePaths.map(item => {

                                return <div className={styles.embla__slide}>
                                    {item.mobilePath ?
                                        <picture >
                                            <source className={styles.image} srcSet={item.mobilePath} media="(max-width: 720px)" />
                                            <img className={styles.image} src={item.desktopPath} />
                                        </picture>
                                        :
                                        <img className={styles.image} src={item.desktopPath} />}
                                </div>
                            }) : null
                        }
                    </div>
                </div>
            </div>

            <div className={styles.imageGalleryGradient}>

            </div>
            <div className={styles.serviceInfo}>
                <div className={styles.serviceInfoTextual}>
                    <h2 className={styles.serviceTitle}>{serviceSection.title}</h2>
                    <div className={styles.serviceDescription}>
                            {activeServiceItem == {} ? serviceSection.serviceDescription :
                                (activeServiceItem.serviceItemDescription ? activeServiceItem.serviceItemDescription : serviceSection.serviceDescription)}

                        </div>
                    {/*<div className={styles.serviceCapsules}>
                        {serviceCapsuleItems ?
                            serviceCapsuleItems.map(item => {
                                return <div id={item.id} tabIndex="0" className={styles.serviceCapsuleLink}
                                ><span className={styles.serviceCapsule}>{item.serviceItemTitle}</span></div>
                            }) : null
                        }
                    </div>
                    <div className={styles.serviceBelt}>
                        <div className={styles.serviceTitleCapsuleCouple}>

                            {serviceSection.serviceTestimonial ?
                                <div className={styles.serviceTestimonial}>
                                    <p className={styles.serviceTestimonialText}>{serviceSection.serviceTestimonial}</p>
                                </div>
                                :
                                null
                            }
                        </div>
                        <p className={styles.serviceDescription}>
                            {activeServiceItem == {} ? serviceSection.serviceDescription :
                                (activeServiceItem.serviceItemDescription ? activeServiceItem.serviceItemDescription : serviceSection.serviceDescription)}

                        </p>

                    </div>*/}
                </div>
                <div className={styles.serviceTiles}>
                    {activeImagePaths ?
                        activeImagePaths.map((item, index) => {
                            return <a id={item.id} tabIndex="0"
                                className={styles.serviceTile + " " + (index == activeImageId ? styles.activeTile : "")}
                                onPointerDown={() => { setActiveImageId(index) }}
                            ><img className={styles.serviceTileImage} src={item.desktopPath} /></a>
                        }) : null
                    }
                </div>
                
            </div>
        </div>



    );
}

export default ServiceSection;
